export default "__VITE_ASSET__e9de55aa__"